
import { useRef, useState, useEffect } from "react";

export function useMicroBeltScroll() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [containerWidth, setContainerWidth] = useState(0);

  const updateContainerWidth = () => {
    if (!scrollContainerRef.current) return;
    setContainerWidth(scrollContainerRef.current.clientWidth);
  };

  const checkScrollability = () => {
    if (!scrollContainerRef.current) return;
    const container = scrollContainerRef.current;
    setCanScrollLeft(container.scrollLeft > 2);
    setCanScrollRight(container.scrollLeft < container.scrollWidth - container.clientWidth - 5);
  };

  useEffect(() => {
    checkScrollability();
    updateContainerWidth();
    const handleResize = () => {
      checkScrollability();
      updateContainerWidth();
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollLeft = () => {
    if (!scrollContainerRef.current) return;
    scrollContainerRef.current.scrollBy({ left: -250, behavior: 'smooth' });
    setTimeout(checkScrollability, 300);
  };

  const scrollRight = () => {
    if (!scrollContainerRef.current) return;
    scrollContainerRef.current.scrollBy({ left: 250, behavior: 'smooth' });
    setTimeout(checkScrollability, 300);
  };

  return {
    scrollContainerRef,
    canScrollLeft,
    canScrollRight,
    containerWidth,
    checkScrollability,
    scrollLeft,
    scrollRight,
    updateContainerWidth,
  };
}
